import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface Message {
    id: string;
    message: string;
    user: string;
}

interface MessagesState {
    messages: Message[];
    isLoading: boolean;
}

const initialState: MessagesState = {
    messages: [],
    isLoading: true,
};

export const messagesSlice = createSlice({
    name: "chatbotMessages",
    initialState,
    reducers: {
        setMessages(state, action: PayloadAction<Message[]>) {
            state.messages = action.payload;
        },
        addMessage(state, action: PayloadAction<Message>) {
            state.messages.push(action.payload);
        },
        appendToLastMessage(state, action: PayloadAction<string>) {
            state.messages[state.messages.length - 1].message += action.payload;
        },
        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
    },
});

export const { setMessages, addMessage, appendToLastMessage, setIsLoading } = messagesSlice.actions;

export default messagesSlice.reducer;
